export function wrapLabel(label, limit) {
    label = String(label);

    if (label === '[object Object]' || Array.isArray(label)) {
        console.warn("Non-string label:", label);
        return [label];
    }

    const words = label.split(" ");
    let aux = [];
    let concat = [];

    for (let i = 0; i < words.length; i++) {
        concat.push(words[i]);
        let join = concat.join(' ');
        if (join.length > limit) {
            aux.push(join);
            concat = [];
        }
    }

    if (concat.length) {
        aux.push(concat.join(' ').trim());
    }

    return aux;
}
